import './professionals-services.css'
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { useFetch } from '../../../hooks/useFetch';
import BlackButton from '../../basic/button'
import PillButton from '../../basic/pill-button'

const Professionals = () => {

    const { data: professionals } = useFetch('https://api.abranches.net.br/Professional/getByEstablishment?establishmentId=dab57196-f743-4f8c-8c68-5d9f90ed1f75');
    const { data: services } = useFetch('https://api.abranches.net.br/Service/get?serviceId=467b4936-dd01-4735-a71d-4aff3657a5f9');

    return (
        <div className='app-container'>
            <p className='app-subtitle'>Serviços / Profissionais</p>
            <div className='service-professional'>
                <div className='service-professional-list'>
                    <ul>
                        {services && services.map((item, index) => (
                            <li key={item.id}>
                                <PillButton Active={index === 0 ? 'true' : 'false'} Label={item.name} />
                            </li>
                        ))}
                    </ul>
                </div>
                <div className='service-professional-list'>
                    <ul>
                        {professionals && professionals.map((item, index) => (
                            <li key={item.id}>
                                <PillButton Active={index === 0 ? 'true' : 'false'} Label={item.name} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Professionals